
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import HistoriesPanel from "@/components/middle-office/tabs/history/HistoriesPanel.vue";
import StatusHistory from "@/components/middle-office/tabs/history/StatusHistory.vue";
import { StatusHistoryVariables } from "@/types";
import moment from "moment";
import Notify from 'quasar/src/plugins/Notify.js';;
@Options({
  components: { HistoriesPanel, StatusHistory },
  props: ["entityState", "historiesStep"],
})
export default class SummaryActionsHistory extends Vue {
  historiesStep?: any;
  expanded = true;
  getDateFormated(date: any) {
    if (date && date !== "") return moment(date).format("DD/MM/YYYY HH:mm");
  }
  getName(value: string) {
    if (value && value !== "") {
      return value.split("##")[0];
    }
  }

 openStatusHistory(row: any) {
   if (typeof row.variables === 'string' && row.variables !== "{}") {
    store.dispatch("middleOfficeModule/setVariablesVisible", true);
    const obj = JSON.parse(row.variables);
    const historiesStepComments = JSON.parse(store.state.middleOfficeModule.historiesStep![0].variables);
    const variablesSelected: StatusHistoryVariables = {
      offerCreationDate: this.getDateFormated(`${row.creationDate || ""} `),
      customerType: obj.customerType?.value,
      offerPhase: obj.offerPhase?.value,
      customerReference: obj.customerReference?.value,
      offerReference: obj.offerReference?.value,
      offerStatus: obj.offerStatus?.value,
      customerName: obj.customerName?.value,
      taskDefinition: row.taskDefinition,
      comment: row.status !== 'completed' ? '': row.taskDefinition === 'STEP_ENTER_DECISION' 
        ? historiesStepComments.decisionComment?.value  || ''
        : row.taskDefinition === 'STEP_ENTER_DELEGATION_LEVEL'
          ? historiesStepComments.delegationLVLComment?.value || ''
          : obj.comment?.value || row.comment || ''
    }
    
    if (obj._clientDecisionStatus != undefined) {
      variablesSelected.clientDecisionStatus = obj._clientDecisionStatus.value
    }
    store.dispatch("middleOfficeModule/setStatusHistoryVariablesSelected", variablesSelected);
  }
  else{
    Notify.create({
      color: 'blue',
      actions: [{ icon: 'close', color: 'white' }],
      message: this.$t('task.historiesStep.headers.histories.noDataMessage'),
    });
  }
}
}
